/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'

import StatikSystemClass from './js/StatikSystem'
import StatikCanvas from './js/StatikCanvas'
import { berechnen } from './js/berechnung'
import Auflager from './js/Auflager'
import Knoten from './js/Knoten'
import Material from './js/Material'
import Querschnitt from './js/Querschnitt'
import Gelenk from './js/Gelenk'
import Stab from './js/Stab'
import Stablast from './js/Stablast'
import Knotenlast from './js/Knotenlast'
import * as d3 from 'd3'

import jsPDF from 'jspdf-yworks/dist/jspdf.min'
import 'jspdf-autotable'
// import cslgreekmedium from './plugins/cslgreekmedium-normal'

import { interactions } from './store/interactions'

const InfoString = 'Statisches System als .rfs-Datei v0.1';

Vue.use(Vuex)

const readUploadedFileAsText = (inputFile) => {
    const temporaryFileReader = new FileReader();
  
    return new Promise((resolve, reject) => {
      temporaryFileReader.onerror = () => {
        temporaryFileReader.abort();
        reject(new DOMException("Problem parsing input file."));
      };
  
      temporaryFileReader.onload = () => {
        resolve(temporaryFileReader.result);
      };
      temporaryFileReader.readAsText(inputFile);
    });
  };

export default new Vuex.Store({
  state: {
    alert: {
        type: undefined,
        msg: '',
    },
    pending: false,
    
    Selection: {
        Knoten: [],
        Stäbe: [],
        Knotenlasten: [],
        Stablasten: []},

    HiddenElements: [],

    vNewDLTMenu: false,
    vNewBalkenkopfRepMenu: false,
    vNewSparrendachMenu: false,
    vNewPfettendachMenu: false,

    initStatus: false,

    newAuflager: false,
    cAuflager: undefined,
    vAuflagerMenu: false,

    newKnoten: false,
    cKnoten: undefined,
    vKnotenMenu: false,

    newMaterial: false,
    cMaterial: undefined,
    vMaterialMenu: false,

    newQuerschnitt: false,
    cQuerschnitt: undefined,
    vQuerschnittMenu: false,

    newGelenk: false,
    cGelenk: undefined,
    vGelenkMenu: false,

    newStab: false,
    cStab: undefined,
    vStabMenu: false,

    newKnotenlast: false,
    cKnotenlast: undefined,
    vKnotenlastMenu: false,

    newStablast: false,
    cStablast: undefined,
    vStablastMenu: false,

    newLastfall: false,
    cLastfall: undefined,
    vLastfallMenu: false,
    vColorPicker: false,

    curLastfall: undefined,

    canvas: undefined,
    StatikSystem: undefined,
    // vBerechnenMenu: false,

    drawNormalkraft: false,
    drawQuerkraft: false,
    drawMoment: false,
    drawVerformung: false,

    LängenEinheiten: {  m:{name: 'm', value: 1},
                        dm:{name: 'dm', value: 0.1},
                        cm:{name:'cm',value: 0.01},
                        mm:{name:'mm',value: 0.001}
                    },
    KraftEinheiten: {   N:{name: 'N', value: 1},
                        kN:{name: 'kN', value: 1000}
                    }
  },

  getters:{
    alert(state) { return state.alert },
    showAlert(state) { return state.alert.msg ? true: false },
    pending(state) { return state.pending },

    initStatus(state) { return state.initStatus },

    Selection(state) { return state.Selection },

    // vBerechnenMenu(state) { return state.vBerechnenMenu },

    vNewDLTMenu(state) { return state.vNewDLTMenu },
    vNewBalkenkopfRepMenu(state) { return state.vNewBalkenkopfRepMenu },
    vNewSparrendachMenu(state) { return state.vNewSparrendachMenu },
    vNewPfettendachMenu(state) { return state.vNewPfettendachMenu },

    cAuflager(state) { return state.cAuflager },
    vAuflagerMenu(state) { return state.vAuflagerMenu },
    newAuflager(state) { return state.newAuflager },
    
    cKnoten(state) { return state.cKnoten },
    vKnotenMenu(state) { return state.vKnotenMenu },
    newKnoten(state) { return state.newKnoten },

    cMaterial(state) { return state.cMaterial },
    vMaterialMenu(state) { return state.vMaterialMenu },
    newMaterial(state) { return state.newMaterial },

    cQuerschnitt(state) { return state.cQuerschnitt },
    vQuerschnittMenu(state) { return state.vQuerschnittMenu },
    newQuerschnitt(state) { return state.newQuerschnitt },
    
    cGelenk(state) { return state.cGelenk },
    vGelenkMenu(state) { return state.vGelenkMenu },
    newGelenk(state) { return state.newGelenk },

    cStab(state) { return state.cStab },
    vStabMenu(state) { return state.vStabMenu },
    newStab(state) { return state.newStab },

    cLastfall(state) { return state.cLastfall },
    vLastfallMenu(state) { return state.vLastfallMenu },
    vColorPicker(state) { return state.vColorPicker },
    newLastfall(state) { return state.newLastfall },
    
    curLastfall(state) { return state.curLastfall },

    cKnotenlast(state) { return state.cKnotenlast },
    vKnotenlastMenu(state) { return state.vKnotenlastMenu },
    newKnotenlast(state) { return state.newKnotenlast },

    cStablast(state) { return state.cStablast },
    vStablastMenu(state) { return state.vStablastMenu },
    newStablast(state) { return state.newStablast },

  },

  mutations: {
    // Draw Options
    DRAW_NORMALKRAFT: (state) => { state.canvas.changeSchnittkraftVisibility('Normalkräfte') },
    DRAW_QUERKRAFT: (state) => { state.canvas.changeSchnittkraftVisibility('Querkräfte') },
    DRAW_MOMENT: (state) => { state.canvas.changeSchnittkraftVisibility('Momente') },
    DRAW_VERFORMUNG: (state) => { state.canvas.changeSchnittkraftVisibility('Verformungen') },
    DRAW_KEINE_SCHNITTKRÄFTE: (state) => { state.canvas.changeSchnittkraftVisibility(null) },
    DRAW_BELASTUNG: (state, payload) =>{ state.canvas.changeBelastungVisibility(payload) },
    DRAW_AUFLAGERKRÄFTE: (state, payload) =>{ state.canvas.changeAuflagerkraftVisibility(payload) },
    
    //   --- Alerts
        setAlert(state, payload){
            state.alert.type = payload.type
            state.alert.msg = payload.msg
        },
        resetAlert(state){
            this.commit('setAlert',{type: undefined, msg: undefined})
        },

    // --- Allgemeines---

        setvNewDLTMenu(state, value) { state.vNewDLTMenu = value },
        setvNewBalkenkopfRepMenu(state, value) { state.vNewBalkenkopfRepMenu = value },

        setvNewSparrendachMenu(state, value) { state.vNewSparrendachMenu = value },
        setvNewPfettendachMenu(state, value) { state.vNewPfettendachMenu = value },

        initStatus(state, payload){
            state.initStatus = payload
        },

        setCurLastfall(state, payload){
            state.curLastfall = payload
            this.dispatch('zeichne')  
        },
    
    // ---Canvas---
        initCanvas(state, payload){
            return new Promise((resolve, reject) =>{
                state.canvas = new StatikCanvas(payload.svg,payload.width,payload.height)
                // this.canvas2 = new StatikCanvas(d3.select('#canvas2'),300,300)  
                state.canvas.DRAW_STABNUMMER = true
                resolve(true)
            })   
        },

        resetSelection(state){
            state.Selection.Knoten = []
            state.Selection.Stäbe = []
            state.Selection.Knotenlasten = []
            state.Selection.Stablasten = []
        },

        selectKnoten(state, payload){
            const List = state.Selection.Knoten
            const i = List.indexOf(payload)
            if (i==-1) List.push(payload)
            else List.splice(i,1)
            payload.d3Node.attrs({'fill': i==-1 ? 'orange' : 'red',})
            console.log(state.Selection)
        },
        drawKnotenSelection(state){
            const List = state.Selection.Knoten            
            state.StatikSystem.Knotenliste.forEach(Knoten =>{
            const i = List.indexOf(Knoten)
            Knoten.d3Node.attrs({'fill': i>-1 ? 'orange' : 'red',})
            })
        },

        selectStab(state, payload){
            const List = state.Selection.Stäbe
            const i = List.indexOf(payload)
            if (i==-1) List.push(payload)
            else List.splice(i,1)
            payload.d3Node.attrs({'stroke': i==-1 ? 'orange' : 'black',})
            console.log(state.Selection)
        },
        drawStabSelection(state){
            const List = state.Selection.Stab            
            state.StatikSystem.Stabliste.forEach(Stab =>{
            const i = List.indexOf(Stab)
            Stab.d3Node.attrs({'stroke': i>-1 ? 'orange' : 'black',})
            })
        },

        selectStablast(state, payload){
            const List = state.Selection.Stablasten
            const i = List.indexOf(payload)
            if (i==-1) List.push(payload)
            else List.splice(i,1)
            payload.d3Node.attrs({'stroke': i==-1 ? 'orange' : 'black',})
            console.log(state.Selection)
        },

    // ---StatikSystem---
        
        resetSystem (state) {
            return new Promise(resolve =>{
                this.commit('initStatus', false)
                this.commit('resetSelection')
                state.cAuflager= undefined
                state.cKnoten= undefined
                state.cStab= undefined
                state.cKnotenlast= undefined
                state.cStablast= undefined
                state.curLastfall= undefined
                Object.keys(state.StatikSystem).forEach(key =>{
                    if (key != 'Bbox'){
                        state.StatikSystem[key].splice(0,state.StatikSystem[key].length)
                    }
                })
                state.StatikSystem.Bbox.left= -10000
                state.StatikSystem.Bbox.right= 10000
                state.StatikSystem.Bbox.top= 10000 
                state.StatikSystem.Bbox.bottom= -10000

                resolve()
            })
        },

        // setvBerechnenMenu(state, value){
        //     state.vBerechnenMenu = value
        // },

    //

    // ---Auflager---
        newAuflager(state){
            state.newAuflager = true
            state.cAuflager = new Auflager(null, 0,0,0,0) 
            this.commit('setvAuflagerMenu', true)
            // state.vAuflagerMenu = true
        },
        editAuflager(state, auflager){
            state.newAuflager = false
            state.cAuflager = auflager
            this.commit('setvAuflagerMenu', true)
            // state.vAuflagerMenu = true
        },
        editAuflager_Table(state,auflager){
            this.dispatch('resetSolutions').then(this.dispatch('zeichne'))  
        },
        AuflagerDialogApply(state, auflager){
            state.vAuflagerMenu = false
            if (state.newAuflager) {
                state.StatikSystem.newAuflager(auflager.Werte[0],auflager.Werte[1],auflager.Werte[2],auflager.Winkel)
            } else {
                state.StatikSystem.editAuflager(state.cAuflager, auflager.Werte[0], auflager.Werte[1], auflager.Werte[2], auflager.Winkel_Degree)
            }
            this.dispatch('resetSolutions').then(this.dispatch('zeichne'))      
        },
        AuflagerDialogDelete(state, payload){
            if (confirm('Soll das Auflager gelöscht werden?')){
                state.vAuflagerMenu = false
                if (payload) state.cAuflager = payload 
                state.StatikSystem.deleteAuflager(state.cAuflager)
                this.dispatch('resetSolutions').then(this.dispatch('zeichne'))   
            }
        },
        setvAuflagerMenu(state, value){
            state.vAuflagerMenu = value
        },
    //

    // ---Knoten---
        newKnoten(state){
            state.newKnoten = true
            state.cKnoten = new Knoten()
            state.vKnotenMenu = true
        },
        editKnoten(state, knoten){
            state.newKnoten = false
            state.cKnoten = knoten
            state.vKnotenMenu = true
            // this.commit('setvKnotenMenu', true)
        },
            // editKnoten_Table(state,knoten){
            //     this.dispatch('resetSolutions').then(this.dispatch('zeichne'))  
            // },
        KnotenDialogApply(state, knoten){
            state.vKnotenMenu = false
            if (state.newKnoten) {
                state.StatikSystem.newKnoten(knoten.x,knoten.y,knoten.Auflager)
            } else {
                state.StatikSystem.editKnoten(state.cKnoten, knoten.x, knoten.y, knoten.Auflager)
            }
            this.dispatch('resetSolutions').then(this.dispatch('zeichne'))
            // this.$emit('on-new-knoten', this.knoten)
        },
        KnotenDialogDelete(state, payload){
            if (confirm('Soll der Knoten gelöscht werden?')){
            state.vKnotenMenu = false
            if (payload) state.cKnoten = payload 
            state.StatikSystem.deleteKnoten(state.cKnoten)
            this.dispatch('resetSolutions').then(this.dispatch('zeichne'))  
            }
        },
        setvKnotenMenu(state, value) {
            state.vKnotenMenu = value
        },
    //

    // ---Materialien---
        newMaterial(state){
            state.newMaterial = true
            state.cMaterial = new Material()
            state.vMaterialMenu = true
        },
        editMaterial(state, material){
            state.newMaterial = false
            state.cMaterial = material
            state.vMaterialMenu = true
        },
        MaterialDialogApply(state, material){
            state.vMaterialMenu = false
            if (state.newMaterial) {
                state.StatikSystem.addMaterial(material)
            } else {
                state.StatikSystem.editMaterial()
            }
            this.dispatch('resetSolutions').then(this.dispatch('zeichne'))  
        },
        MaterialDialogDelete(state, payload){
            if (confirm('Soll das Material gelöscht werden?')){
                if (state.cMaterial.Querschnittliste.length > 0) return this.commit('setAlert',{type: 'warning', msg: 'Das Material kann nicht gelöscht werden. Es wird noch verwendet.'})
                state.vMaterialMenu = false
                if (payload) state.cMaterial = payload
                state.StatikSystem.deleteMaterial(state.cMaterial)                 
            }
        },
        setvMaterialMenu(state, value){
            state.vMaterialMenu = value
        },
    //

    // ---Querschnitte---
        newQuerschnitt(state){
            state.newQuerschnitt = true
            state.cQuerschnitt = new Querschnitt()
            state.vQuerschnittMenu = true
        },
        editQuerschnitt(state, querschnitt){
            state.newQuerschnitt = false
            state.cQuerschnitt = querschnitt
            state.vQuerschnittMenu = true
        },
        QuerschnittDialogApply(state, querschnitt){
            state.vQuerschnittMenu = false
            if (state.newQuerschnitt) {
                state.StatikSystem.addQuerschnitt(querschnitt)
            } else {
                state.StatikSystem.editQuerschnitt(state.cQuerschnitt,querschnitt.Fläche,querschnitt.Trägheitsmoment,querschnitt.Material,querschnitt.name)
            }
            this.dispatch('resetSolutions').then(this.dispatch('zeichne'))              
        },
        QuerschnittDialogDelete(state, payload){
            if (confirm('Soll der Querschnitt gelöscht werden?')){
                if (state.cQuerschnitt.Stabliste.length > 0) return this.commit('setAlert',{type: 'warning', msg: 'Der Querschnitt kann nicht gelöscht werden. Es wird noch verwendet.'})
                state.vQuerschnittMenu = false
                if (payload) state.cQuerschnitt = payload
                state.StatikSystem.deleteQuerschnitt(state.cQuerschnitt)
            }
        },
        setvQuerschnittMenu(state, value){
            state.vQuerschnittMenu = value
        },
    //

    // ---Gelenke---
        newGelenk(state){
            state.newGelenk = true
            state.cGelenk = new Gelenk(null, -1,-1,-1) 
            state.vGelenkMenu = true
        },
        editGelenk(state, gelenk){
            state.newGelenk = false
            state.cGelenk = gelenk
            state.vGelenkMenu = true
        },
        GelenkDialogApply(state, gelenk){
            state.vGelenkMenu = false
            if (state.newGelenk) {
                state.StatikSystem.addGelenk(gelenk)
            } else {
                state.StatikSystem.editGelenk(state.cGelenk, gelenk.Werte[0], gelenk.Werte[1], gelenk.Werte[2])
            }
            this.dispatch('resetSolutions').then(this.dispatch('zeichne'))      
        },
        GelenkDialogDelete(state, payload){
            if (confirm('Soll das Gelenk gelöscht werden?')){
                state.vGelenkMenu = false
                if (payload) state.cGelenk = payload
                state.StatikSystem.deleteGelenk(state.cGelenk)
                this.dispatch('resetSolutions').then(this.dispatch('zeichne'))   
            }
        },
        setvGelenkMenu(state, value) {
            state.vGelenkMenu = value
        },
    // 

    // ---Stäbe---
        newStab(state){
            state.newStab = true
            state.cStab = new Stab()
            state.vStabMenu = true
        },  
        editStab(state, stab){
            state.newStab = false
            state.cStab = stab
            state.vStabMenu = true      
        },
        //    async StabDialogApply(state, stab){
        //         // state.vStabMenu = false
        //         if (state.newStab) {
        //            await state.StatikSystem.addStab(stab)
        //         } else {
        //            await state.StatikSystem.editStab(state.cStab, stab.StartKnoten, stab.EndKnoten, stab.Querschnitt, stab.isFachwerkstab, stab.StartGelenk, stab.EndGelenk, stab.Stabteilungen)
        //         }
        //         await this.dispatch('resetSolutions').then(this.dispatch('zeichne'));
                
        //     },
        StabDialogDelete(state, payload){
            if (confirm('Soll der Stab gelöscht werden?')){
                state.vStabMenu = false
                if (payload) state.cStab = payload
                state.StatikSystem.deleteStab(state.cStab)
                this.dispatch('resetSolutions').then(this.dispatch('zeichne'))  
            }
        },
        setvStabMenu(state, value) {
            state.vStabMenu = value
        },
    //

    // ---Lastfälle
        newLastfall(state){
            state.newLastfall = true
            // state.cLastfall = new Lastfall()
            state.vLastfallMenu = true
        },
        editLastfall(state, lastfall){

        },
        LastfallDialogApply(state, lastfall){
            state.vLastfallMenu = false
            if (state.newLastfall) {
                state.StatikSystem.addLastfall(lastfall)
            } else {
                state.StatikSystem.editLastfall(state.cLastfall, lastfall.name, lastfall.Color)
            }
            // this.dispatch('zeichne')
        },
        setvLastfallMenu(state, value){
            state.vLastfallMenu = value
        },
        setvColorPicker(state, value){
            state.vColorPicker = value
        },
        setColor(state,color){
            state.cLastfall.Color = color
            this.dispatch('resetSolutions').then(this.dispatch('zeichne'))  
        },

    // 

    // ---Knotenlasten---
        newKnotenlast(state){
            state.newKnotenlast = true
            state.cKnotenlast = new Knotenlast(undefined,0,0,0,undefined,state.curLastfall ? state.curLastfall : undefined)
            state.vKnotenlastMenu = true
        },
        editKnotenlast(state, knotenlast){
            state.newKnotenlast = false
            state.cKnotenlast = knotenlast
            state.vKnotenlastMenu = true      
        },
        KnotenlastDialogApply(state, knotenlast){
            state.vKnotenlastMenu = false
            if (state.newKnotenlast) {
                knotenlast.Lastfall.addKnotenlast(knotenlast)
            } else {
                knotenlast.Lastfall.editKnotenlast(state.cKnotenlast, knotenlast.fX, knotenlast.fY, knotenlast.M, knotenlast.Knotenliste)
            }
            this.dispatch('resetSolutions').then(this.dispatch('zeichne'))  
        },
        KnotenlastDialogDelete(state, payload){
            if (confirm('Soll die Knotenlast gelöscht werden?')){
                state.vKnotenlastMenu = false
                if (payload) state.cKnotenlast = payload
                state.cKnotenlast.Lastfall.deleteKnotenlast(state.cKnotenlast)
                this.dispatch('resetSolutions').then(this.dispatch('zeichne'))  
            }
        },
        setvKnotenlastMenu(state, value){
            state.vKnotenlastMenu = value
        },
    //

    // ---Stablasten---
        newStablast(state){
            state.newStablast = true
            state.cStablast = new Stablast(undefined,0,0,0,0,undefined,state.curLastfall ? state.curLastfall : undefined)
            state.vStablastMenu = true
        },
        editStablast(state, stablast){
            state.newStablast = false
            state.cStablast = stablast
            state.vStablastMenu = true      
        },
        StablastDialogApply(state, stablast){
            state.vStablastMenu = false
            if (state.newStablast) {
                stablast.Lastfall.addStablast(stablast)
            } else {
                stablast.Lastfall.editStablast(state.cStablast, stablast.p1, stablast.p2, stablast.Orientierung, stablast.Bezugslänge, stablast.Stabliste)
            }
            this.dispatch('resetSolutions').then(this.dispatch('zeichne'))  
        },
        StablastDialogDelete(state, payload){
            if (confirm('Soll die Stablast gelöscht werden?')){
                state.vStablastMenu = false
                if (payload) state.cStablast = payload
                state.cStablast.Lastfall.deleteStablast(state.cStablast)
                this.dispatch('resetSolutions').then(this.dispatch('zeichne'))
            }
        },
        setvStablastMenu(state, value){
            state.vStablastMenu = value
        },
    //

    // ---Sonstiges---

  },

  actions: {
    async StabDialogApply(context, stab){
        // state.vStabMenu = false
        if (context.state.newStab) {
           await context.state.StatikSystem.addStab(stab)
        } else {
            context.state.vStabMenu = false
           await context.state.StatikSystem.editStab(context.state.cStab, stab.StartKnoten, stab.EndKnoten, stab.Querschnitt, stab.isFachwerkstab, stab.StartGelenk, stab.EndGelenk, stab.Stabteilungen)
        }
        await context.dispatch('resetSolutions').then(context.dispatch('zeichne'));
    },




    initStatikSystem(context){
        let nStatikSystem = new StatikSystemClass()
        // let matTest = nStatikSystem.newMaterial(1,1,'Test')
        let MatHolz = nStatikSystem.newMaterial(1.1e+10,5000,'Holz')
        let MatStahl = nStatikSystem.newMaterial(2.1e+12,78500,'Stahl')
        // let querTest = nStatikSystem.newQuerschnitt(1,1,matTest,'TestQuerschnitt')
        let Querschnitt1 = nStatikSystem.newQuerschnitt(0.06,4.5e-4,MatHolz,'Holzbalken')
        // let Querschnitt2 = nStatikSystem.newQuerschnitt(1.44e-2,1.728e-5,MatHolz,'12/12 C24')

        let Auflager1 = nStatikSystem.newAuflager(-1,-1,0,0)
        let Auflager2 = nStatikSystem.newAuflager(0,45000000,0,0)
        // let Auflager3 = nStatikSystem.newAuflager(0,-1,0,0)

        let Knoten1 = nStatikSystem.newKnoten(0,0,Auflager1)
        let Knoten2 = nStatikSystem.newKnoten(2,2)
        let Knoten3 = nStatikSystem.newKnoten(4,4)            
        // let Knoten2 = state.StatikSystem.newKnoten(0.75,1.00)
        // let Knoten3 = state.StatikSystem.newKnoten(1.50,2.00)
        let Knoten4 = nStatikSystem.newKnoten(6,2)
        let Knoten5 = nStatikSystem.newKnoten(8,0,Auflager2)

        let GelenkM = nStatikSystem.newGelenk(-1,-1,0)

        let Stab1 = nStatikSystem.newStab(Knoten1, Knoten2, Querschnitt1, null, null, false)
        let Stab2 = nStatikSystem.newStab(Knoten2, Knoten3, Querschnitt1, null, null, false)
        let Stab3 = nStatikSystem.newStab(Knoten3, Knoten4, Querschnitt1, GelenkM, null, false)
        let Stab4 = nStatikSystem.newStab(Knoten4, Knoten5, Querschnitt1, null, null, false)
        let Stab5 = nStatikSystem.newStab(Knoten2, Knoten4, Querschnitt1, null, null, true,2)
        let Stab6 = nStatikSystem.newStab(Knoten1, Knoten5, Querschnitt1, null, null, true,2)

        let Lastfall1 = nStatikSystem.newLastfall('ständige Last', 'brown');
        // let Lastfall2 = nStatikSystem.newLastfall('Schnee','#a7d7ef');

        // Lastfall1.newKnotenlast(0,40000,0,[Knoten2])

        Lastfall1.newStablast(2000,2000,0,0,[Stab1,Stab2,Stab3,Stab4])

        context.state.StatikSystem = nStatikSystem
        context.commit('initStatus', true)
        context.commit('setCurLastfall', Lastfall1)  
        // Zeinen wird bereits beim Ändern des lastfalls aufgerufen.
        // context.dispatch('zeichne')
    },

    newDLT(context, payload){
        context.commit('resetAlert')
        context.commit('resetSystem')
        
        // let matTest = context.state.StatikSystem.newMaterial(1,1,'Test')
        // let querTest = context.state.StatikSystem.newQuerschnitt(1,1,matTest,'TestQuerschnitt')


        let MatHolz = context.state.StatikSystem.newMaterial(1.1e+10,5000,'Holz')
        let MatStahl = context.state.StatikSystem.newMaterial(2.1e+12,78500,'Stahl')
        let Querschnitt1 = context.state.StatikSystem.newQuerschnitt(0.032,1.066666667e-4,MatHolz,'Holzbalken 16/20')
        let Auflager1 = context.state.StatikSystem.newAuflager(-1,-1,0,0)
        let Auflager2 = context.state.StatikSystem.newAuflager(0,-1,0,0)
        let knotenliste = []
        let x = 0
        knotenliste.push(context.state.StatikSystem.newKnoten(0,0, payload.kragarmLinks.enabled ? null : Auflager1))
        if (payload.kragarmLinks.enabled) {
            x += payload.kragarmLinks.länge    
            knotenliste.push(context.state.StatikSystem.newKnoten(x,0,Auflager1))
        }
        
        for (let i = 0; i<payload.Felder.length; i++){
            x += payload.Felder[i].länge
            knotenliste.push(context.state.StatikSystem.newKnoten(x,0,Auflager2))
        }
        if (payload.kragarmRechts.enabled) {
            x += payload.kragarmRechts.länge    
            knotenliste.push(context.state.StatikSystem.newKnoten(x,0))
        }

        for (let i = 1; i<knotenliste.length; i++){
            context.state.StatikSystem.newStab(knotenliste[i-1], knotenliste[i], Querschnitt1, null, null, false)            
            //context.state.StatikSystem.newStab(knotenliste[i-1], knotenliste[i], Querschnitt1, null, null, false)
        }

        let Lastfall1 = context.state.StatikSystem.newLastfall('ständige Last', 'brown');
        context.commit('setCurLastfall', Lastfall1)
        context.commit('initStatus', true)
    },

    newBalkenkopfRep(context, payload){
        context.commit('resetAlert')
        context.commit('resetSystem')

        let MatHolz = context.state.StatikSystem.newMaterial(1.1e+10,5000,'Holz')
        let Querschnitt1 = context.state.StatikSystem.newQuerschnitt(0.032,1.066666667e-4,MatHolz,'Holzbalken 16/20')
        let Querschnitt2 = context.state.StatikSystem.newQuerschnitt(0.0166666,5.3333333333333e-5,MatHolz,'Holzbalken 8/20')        
        let Auflager1 = context.state.StatikSystem.newAuflager(-1,-1,0,0)
        let Auflager2 = context.state.StatikSystem.newAuflager(0,-1,0,0)
        let knotenliste = []
        let x = 0
        knotenliste.push(context.state.StatikSystem.newKnoten(0,0.5,Auflager1))
        knotenliste.push(context.state.StatikSystem.newKnoten(payload.Schadlänge-payload.Blattlänge+payload.Randabstand,0.5,null))
        knotenliste.push(context.state.StatikSystem.newKnoten(payload.Schadlänge-payload.Randabstand,0.5,null))
        knotenliste.push(context.state.StatikSystem.newKnoten(payload.Schadlänge-payload.Blattlänge+payload.Randabstand,0,null))
        knotenliste.push(context.state.StatikSystem.newKnoten(payload.Schadlänge-payload.Randabstand,0,null))
        knotenliste.push(context.state.StatikSystem.newKnoten(payload.Spannweite,0,Auflager1))

        let Stab1 = context.state.StatikSystem.newStab(knotenliste[0], knotenliste[1], Querschnitt1, null, null, false,6)  
        let Stab2 = context.state.StatikSystem.newStab(knotenliste[1], knotenliste[2], Querschnitt2, null, null, false,3)
        let Stab3 = context.state.StatikSystem.newStab(knotenliste[3], knotenliste[4], Querschnitt2, null, null, false,3)
        let Stab4 = context.state.StatikSystem.newStab(knotenliste[4], knotenliste[5], Querschnitt1, null, null, false,6)
        let Stab5 = context.state.StatikSystem.newStab(knotenliste[1], knotenliste[3], Querschnitt1, null, null, true,2)
        let Stab6 = context.state.StatikSystem.newStab(knotenliste[2], knotenliste[4], Querschnitt1, null, null, true,2)

        let Lastfall1 = context.state.StatikSystem.newLastfall('ständige Last', 'brown');
        Lastfall1.newStablast(payload.Belastung,payload.Belastung,0,0,[Stab1,Stab4])
        Lastfall1.newStablast(payload.Belastung/2,payload.Belastung/2,0,0,[Stab2,Stab3])

        context.commit('setCurLastfall', Lastfall1)
        context.commit('initStatus', true)
    },

    newSystem(context){
        context.commit('resetAlert')
        context.commit('resetSystem')
        let MatHolz = context.state.StatikSystem.newMaterial(1.1e+10,5000,'Holz')
        let MatStahl = context.state.StatikSystem.newMaterial(2.1e+12,78500,'Stahl')
        context.state.StatikSystem.newQuerschnitt(0.032,1.066666667e-4,MatHolz,'Holzbalken 16/20')
        // let MatStahl = context.state.StatikSystem.newMaterial(2.1e+8,0,'Stahl')
        // let Querschnitt1 = context.state.StatikSystem.newQuerschnitt(2e-3,5e-5,MatStahl)
        let Lastfall1 = context.state.StatikSystem.newLastfall('ständige Last', 'brown');
        context.commit('initStatus', true)
        context.dispatch('zeichne')    
    },
    loadSystem(context, file){

        context.commit('resetAlert')

        readUploadedFileAsText(file)
        .then(text =>{
            const loadObj = JSON.parse(text) 
            // ---Check ob die Datei gültig ist---
            if (loadObj.Info != InfoString) return context.commit('setAlert',{type: 'error', msg: 'Die geladene Datei hat das falsche Format'})
            // ---Einlesen der Objekte--- 
            context.commit('resetSystem')
            // Materialien
            console.log('Lade Materialien')
            loadObj.Materialien.forEach(element =>{
                context.state.StatikSystem.newMaterial(element.Emodul, element.Wichte, element.Name)
            });
            // Querschnitte
            console.log('Lade Querschnitte')
            loadObj.Querschnitte.forEach(element =>{
                const curMat = context.state.StatikSystem.Materialliste[element.Material-1]
                context.state.StatikSystem.newQuerschnitt(element.Fläche,element.Trägheitsmoment,curMat,element._name)
            })
            // Auflager
            loadObj.Auflager.forEach(element =>{
                context.state.StatikSystem.newAuflager(element.Werte[0],element.Werte[1],element.Werte[2],Math.degrees(element.Winkel))
            })
            // Knoten
            console.log('Lade Knoten')
            loadObj.Knoten.forEach(element =>{
                const curAuflager = context.state.StatikSystem.Auflagerliste[element.Auflager-1]
                context.state.StatikSystem.newKnoten(element.Vec2.x,element.Vec2.y,curAuflager)
            })
            // Gelenke
            console.log('Lade Gelenke')
            loadObj.Gelenke.forEach(element =>{
                context.state.StatikSystem.newGelenk(element.Werte[0],element.Werte[1],element.Werte[2])
            })

            // Stäbe
            console.log('Lade Stäbe')
            loadObj.Stäbe.forEach(element =>{
                const curKnoten1 = context.state.StatikSystem.Knotenliste[element.Knoten.start-1]
                const curKnoten2 = context.state.StatikSystem.Knotenliste[element.Knoten.end-1] 
                const curGelenk1 = element.Gelenke.start ? context.state.StatikSystem.Gelenkliste[element.Gelenke.start-1] : null
                const curGelenk2 = element.Gelenke.end ? context.state.StatikSystem.Gelenkliste[element.Gelenke.end-1] : null
                const curQuerschnitt = context.state.StatikSystem.Querschnittliste[element.Querschnitt-1]
                context.state.StatikSystem.newStab(curKnoten1, curKnoten2, curQuerschnitt, curGelenk1, curGelenk2, element.cFachwerkstab, element.Stabteilungen)
            })

            // Lastfälle
            console.log('Lade Lastfälle')
            loadObj.Lastfälle.forEach(element =>{
                let curLastfall = context.state.StatikSystem.newLastfall(element.name, element.Color)
                element.Knotenlastliste.forEach(knotenlast =>{
                    const curKnotenliste = knotenlast.Knotenliste.map(i => context.state.StatikSystem.Knotenliste[i-1])
                    curLastfall.newKnotenlast(knotenlast.Werte[0],knotenlast.Werte[1],knotenlast.Werte[2],curKnotenliste)
                })
                element.Stablastliste.forEach(stablast =>{
                    const curStabliste = stablast.Stabliste.map(i => context.state.StatikSystem.Stabliste[i-1])
                    curLastfall.newStablast(stablast.Werte[0],stablast.Werte[1],stablast.Orientierung,stablast.Bezugslänge,curStabliste)
                        // "Werte":[0,0,1,1],"Orientierung":0,"Projection":null,"Stabliste":[1,2])
                })
                context.commit('setCurLastfall', curLastfall)   
            })
            context.commit('initStatus', true)
            // context.dispatch('zeichne')  
            return true  
        })
    },
    saveSystem(context){        
        // Materialien
        let matJSON = JSON.stringify(context.state.StatikSystem.Materialliste, ['Emodul', 'Name', 'Wichte'])
        // Querschnitte
        let querschnJSON = JSON.stringify(context.state.StatikSystem.Querschnittliste, (key, value)=>{
            if (key == 'list' || key == 'Stabliste') return undefined
            else if (key == 'Material') return value.number
            else return value
        })
        // Auflager
        let auflJSON = JSON.stringify(context.state.StatikSystem.Auflagerliste, (key, value)=>{
            if (key == 'list' || key == 'Knotenliste') return undefined
            else return value
        })
        // Knoten
        let knotJSON = JSON.stringify(context.state.StatikSystem.Knotenliste, (key, value)=>{
            if (key == 'list' || key == 'Stabliste' || key == 'Freiheitsgrade' || key == 'd3Node') return undefined
            if (key == 'Auflager') return value ? value.number : null
            else return value
        })
        // Gelenke
        let gelJSON = JSON.stringify(context.state.StatikSystem.Gelenkliste, (key, value)=>{
            if (key == 'list' || key == 'Stabliste') return undefined
            else return value
        })
        // Stäbe
        let stäbJSON = JSON.stringify(context.state.StatikSystem.Stabliste, (key, value) =>{
            if (key == 'list' || key == 'Freiheitsgrade' || key == 'd3Node') return undefined
            if (key == 'Gelenke' || key == 'Knoten') return {'start': value[0] ? value[0].number : null, 'end': value[1] ? value[1].number : null}
            if (key == 'Querschnitt') return value.number
            else return value
        })
        // Lastfälle
        let lastfJSON = JSON.stringify(context.state.StatikSystem.Lastfallliste, (key, value) =>{
            if (key == 'list' || key == 'Auflagerreaktionen' || key == 'Ergebnisvektor' || key == 'Berechnet' || key == 'MaxWerte' || key == 'Schnittkräfte') return undefined
            if (key == 'Knotenlastliste'){
                value = JSON.stringify(value, (key1, value1) =>{
                    if (key1 == 'list' || key1 == 'Lastfall' || key == 'd3Node') return undefined
                    if (key1 == 'Knotenliste'){
                        let retArr = []
                        value1.forEach(knoten => retArr.push(knoten.number))
                        return retArr
                    }
                    else return value1
                }) 
                return JSON.parse(value)
            }
            if (key == 'Stablastliste'){
                value = JSON.stringify(value, (key1, value1) =>{
                    if (key1 == 'list' || key1 == 'Lastfall' || key == 'd3Node') return undefined
                    if (key1 == 'Stabliste'){
                        let retArr = []
                        value1.forEach(stab => retArr.push(stab.number))
                        return retArr
                    }
                    else return value1
                })
                return JSON.parse(value)
            }
            else {
                return value
            }
        })

        // Zusammenstellen in ein gemeinsames JSON-Objekt
        let save ={
            Info: InfoString,
            Materialien: JSON.parse(matJSON),
            Querschnitte: JSON.parse(querschnJSON),
            Auflager: JSON.parse(auflJSON),
            Knoten: JSON.parse(knotJSON),
            Gelenke: JSON.parse(gelJSON),
            Stäbe: JSON.parse(stäbJSON),
            Lastfälle: JSON.parse(lastfJSON),
        }

        var saveBlob = new Blob([JSON.stringify(save)], {type : 'application/json'});
        var saveUrl = URL.createObjectURL(saveBlob);
        var downloadLink = document.createElement("a");
        downloadLink.href = saveUrl;
        downloadLink.download = 'StatikSystem.rfs';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    },
    initCanvas (context, payload) {
        context.commit('initCanvas', payload)
    },
    resetSolutions(context){
        context.state.StatikSystem.Lastfallliste.forEach(lastfall => lastfall.Berechnet = false)
    },
    async zeichne(context) {
        this.commit('resetSelection')
        const drawOptions ={
            Lastfall: context.state.curLastfall ? context.state.curLastfall : context.state.StatikSystem.Lastfallliste[0],
            drawAuflagerreaktionen: true,
            drawNormalkraft: context.state.drawNormalkraft,
            HiddenElements: context.state.HiddenElements
            //weitere Zeichnungsoptionen
        }
        context.state.canvas.drawSystem(context.state.StatikSystem, drawOptions)
    },
    resetAndRedraw(context) {
        this.dispatch('resetSolutions').then(this.dispatch('zeichne'))  
    },
    async berechne(context, lastfall) {
        context.commit('resetAlert')
        if (!lastfall) {
            if (context.state.StatikSystem.Lastfallliste.length) {
                lastfall = context.state.StatikSystem.Lastfallliste[0]
            }
            else {
                return context.commit('setAlert',{type: 'warning', msg: 'Es ist kein Lastfall vorhanden.'})
            }
        }
        let result = await context.state.StatikSystem.berechne(context.state.StatikSystem, lastfall)

        if (!result) context.commit('setAlert', {type: 'warning', msg: 'Das System ist verschieblich. Die Ergebnisse sind somit unbrauchbar. Bitte das System korrigieren.'})
        context.dispatch('zeichne')            
    },

    // Funktionen für das ausgeben einer PDF---
    async SvgToPng(context, payload){
        const doctype = '<?xml version="1.0" standalone="no"?>'+'<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">';
        return new Promise( async (resolve, reject) => {
            let svgString = await context.dispatch('StyleSVG',payload)
            var blob = new Blob([ doctype + svgString], { type: 'image/svg+xml;charset=utf-8' });
            var url = window.URL.createObjectURL(blob);
            var img = new Image();

            let canvas = document.createElement('canvas');
            canvas.width  = 2126 //context.state.canvas.canvas.attr('width')*1.2;
            canvas.height = 945 //context.state.canvas.canvas.attr('height')*1.2;
            let ctx = canvas.getContext("2d");

            img.onload = function() {
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                ctx.fillStyle = 'white';
                ctx.globalCompositeOperation = "destination-over";
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                let canvasURL = canvas.toDataURL("image/jpeg");
                resolve(canvasURL)
            };
            img.src = url;
          })
    },

    StyleSVG(context, payload){
        return new Promise((resolve, reject) =>{
            let svg = d3.select('#canvas1').clone(true)    
            let box = svg.attr('viewBox').split(',').map(x => parseInt(x))
            svg.selectAll('svg > #Belastung').attr('visibility',payload.Belastung ? 'visible':'hidden')
            svg.selectAll('svg > #Auflagerreaktionen').attr('visibility',payload.Auflagerreaktionen ? 'visible':'hidden')

            let schnittkraftGruppe = svg.selectAll('svg > #Schnittkräfte')
            schnittkraftGruppe.selectAll('#Normalkräfte, #Querkräfte, #Momente, #Verformungen').attr('visibility', 'hidden')
            if (payload.Schnittkräfte){
                if (payload.Schnittkräfte.Normalkräfte) schnittkraftGruppe.selectAll('#Normalkräfte').attr('visibility', 'visible')
                if (payload.Schnittkräfte.Querkräfte) schnittkraftGruppe.selectAll('#Querkräfte').attr('visibility', 'visible')
                if (payload.Schnittkräfte.Momente) schnittkraftGruppe.selectAll('#Momente').attr('visibility', 'visible')
                if (payload.Schnittkräfte.Verformungen) schnittkraftGruppe.selectAll('#Verformungen').attr('visibility', 'visible')                
            }

            svg.select()
            // var svgString = svg.node()
            var svgString = new XMLSerializer().serializeToString(svg.node())
            svg.remove()   
            resolve(svgString)
        })
    },

    printPdfHead(context, pdf){
        const width = pdf.internal.pageSize.getWidth()
        const height = pdf.internal.pageSize.getHeight()
        return new Promise((resolve, reject) =>{
            pdf.setFontSize(18)
            pdf.setFontType('bold')
            pdf.text('Rem-FEM',20, 15)
            pdf.setFontSize(10); pdf.setFontType('normal')
            // pdf.text('Ausdruckprotokoll noch in Bearbeitung.',60,15)
            pdf.text('Seite: '+pdf.internal.getNumberOfPages(), width-10,15 , {align: 'right'})
            pdf.line(20, 18, 200, 18)
            resolve(pdf)
        })
    },
    async CheckNewPage(context, payload){
        const PageHeight = payload.doc.getPageHeight()
        const res = payload.height+payload.curPos.y
        if (res > PageHeight){
            payload.doc.addPage(); 
            await context.dispatch('printPdfHead', payload.doc); 
            payload.curPos.y = 25
        }
    },
    async print(context){
        context.state.pending = true
        const pdf = new jsPDF({
            orientation: 'p',
            unit: 'mm',
            format: 'a4',
            putOnlyUsedFonts: false, //true,
            compress: false
            }
        );
        pdf.setProperties({
            title: 'Rem-FEM Document',
            subject: 'This is the subject',
            author: 'Rem-FEM',
            keywords: 'Stabwerk',
            creator: 'author'
        });

        let curPos = {y: 0}
        await context.dispatch('printPdfHead', pdf)
       
        curPos.y=28; pdf.setFontSize(16); pdf.text(20, curPos.y, 'Position:'); curPos.y+=10

        pdf.setFontSize(12);pdf.setFontType('normal'); pdf.text(20, curPos.y, 'System:'); curPos.y+=3
        
        let imgHight = 80 //180/context.state.canvas.canvas.attr('width')*context.state.canvas.canvas.attr('height')
        pdf.addImage(await context.dispatch('SvgToPng',{Knoten: true, Stäbe: true, Auflager: true, Belastung: false, Auflagerreaktionen: false}), 'PNG', 20, curPos.y, 180, imgHight)
        curPos.y+= (imgHight+5)

        pdf.setFontSize(10);pdf.setFontType('normal'); pdf.text(20, curPos.y, 'Auflager:'); curPos.y+=1
        pdf.autoTable({
            startY: curPos.y,
            head: [ ['Nummer', 'X-Wert', 'Y-Wert', 'phi-Wert', 'Drehung'],],
            body: context.state.StatikSystem.Auflagerliste.map(obj=>{ return [obj.name,obj.Werte[0],obj.Werte[1],obj.Werte[2],obj.Winkel_Degree] }),
            // tableWidth: 'wrap',
            styles: {cellPadding: 0.5, fontSize: 8},
            margin: {left: 20, right: 10},
            theme: 'grid',
            headStyles: {
                fillColor: [150, 150, 150],
                textColor: 0
            },
        });

        pdf.setFontSize(10);pdf.setFontType('normal'); pdf.text(20, curPos.y=pdf.previousAutoTable.finalY+5, 'Knoten:'); curPos.y+=1
        pdf.autoTable({
            startY: curPos.y,
            head: [ ['Nummer', 'X-Koordinate', 'Y-Koordinate', 'Auflager'],],
            body: context.state.StatikSystem.Knotenliste.map(obj=>{ return [obj.name,obj.x.toFixed(2),obj.y.toFixed(2),obj.Auflager ? obj.Auflager.name : '-'] }),
            // tableWidth: 'wrap',
            styles: {cellPadding: 0.5, fontSize: 8},
            margin: {left: 20, right: 10},
            theme: 'grid',
            headStyles: {
                fillColor: [150, 150, 150],
                textColor: 0
            },
        });

        pdf.setFontSize(10);pdf.setFontType('normal'); pdf.text(20, curPos.y=pdf.previousAutoTable.finalY+5, 'Querschnitte:'); curPos.y+=1
        pdf.autoTable({
            startY: curPos.y,
            head: [ {name: 'Name', area: 'Fläche', area4: 'Trägheitsmoment', material: 'Material', ea: 'EA', ei: 'EI'} ],
            headStyles: { 
                fillColor: [150, 150, 150],
                textColor: 0
                // 1: { fillColor: [150, 150, 150], textColor: 0, halign: 'left'},
                // 2: { fillColor: [150, 150, 150], textColor: 0, halign: 'right'},
                // 3: { fillColor: [150, 150, 150], textColor: 0, halign: 'right'},
                // name: { fillColor: [150, 150, 150], textColor: 0, halign: 'left'},
                // name: { fillColor: [150, 150, 150], textColor: 0, halign: 'left'},
                // name: { fillColor: [150, 150, 150], textColor: 0, halign: 'left'},
            },
            body: context.state.StatikSystem.Querschnittliste.map(obj=>{ return [obj.name,obj.Fläche,obj.Trägheitsmoment,obj.materialName,obj.EA,obj.EI] }),

            styles: {cellPadding: 0.5, fontSize: 8},
            margin: {left: 20, right: 10},
            theme: 'grid',
            columnStyles: { 1: { halign: 'right',}, 2: { halign: 'right'}, 4: { halign: 'right'}, 5: { halign: 'right'} },

            });        

        pdf.setFontSize(10);pdf.setFontType('normal'); pdf.text(20, curPos.y=pdf.previousAutoTable.finalY+5, 'Stäbe:'); curPos.y+=1
        pdf.autoTable({
            startY: curPos.y,
            head: [ ['Nummer', 'Startknoten', 'Endknoten', 'Querschnitt', 'Fachwerkstab'],],
            body: context.state.StatikSystem.Stabliste.map(obj=>{ return [obj.name,obj.StartKnoten.name,obj.EndKnoten.name,obj.Querschnitt.name, obj.isFachwerkstab ? 'ja': 'nein'] }),
            // tableWidth: 'wrap',
            styles: {cellPadding: 0.5, fontSize: 8},
            margin: {left: 20, right: 10},
            theme: 'grid',

            headStyles: {
                fillColor: [150, 150, 150],
                textColor: 0
            },
        });

        curPos.y = pdf.previousAutoTable.finalY+8
        await context.dispatch('CheckNewPage', {doc: pdf, curPos, height: imgHight+7})
        pdf.setFontSize(12);pdf.setFontType('normal'); pdf.text(20, curPos.y, 'Belastung:');pdf.setFontSize(10); pdf.text(40, curPos.y, context.state.curLastfall.name); pdf.setFontSize(12);curPos.y+=3
        pdf.addImage(await context.dispatch('SvgToPng',{Knoten: true, Stäbe: true, Auflager: true, Belastung: true, Auflagerreaktionen: true,}), 'PNG', 20, curPos.y, 180, imgHight)
        curPos.y+= (imgHight+5)
        if (context.state.curLastfall.Berechnet){
            await context.dispatch('CheckNewPage', {doc: pdf, curPos: curPos, height: imgHight+7})
            pdf.setFontSize(12);pdf.setFontType('normal'); pdf.text(20, curPos.y, 'Normalkäfte:'); curPos.y+=3
            pdf.addImage(await context.dispatch('SvgToPng',{Knoten: true, Stäbe: true, Auflager: true, Belastung: false, Auflagerreaktionen: true, Schnittkräfte: {Normalkräfte: true, Querkräfte: false, Momente: false}}), 'PNG', 20, curPos.y, 180, imgHight)
            curPos.y+= (imgHight+8)
            await context.dispatch('CheckNewPage', {doc: pdf, curPos: curPos, height: imgHight+7})
            pdf.setFontSize(12);pdf.setFontType('normal'); pdf.text(20, curPos.y, 'Querkräfte:'); curPos.y+=3
            pdf.addImage(await context.dispatch('SvgToPng',{Knoten: true, Stäbe: true, Auflager: true, Belastung: false, Auflagerreaktionen: true, Schnittkräfte: {Normalkräfte: false, Querkräfte: true, Momente: false}}), 'PNG', 20, curPos.y, 180, imgHight)
            curPos.y+= (imgHight+8)
            await context.dispatch('CheckNewPage', {doc: pdf, curPos: curPos, height: imgHight+7})
            pdf.setFontSize(12);pdf.setFontType('normal'); pdf.text(20, curPos.y, 'Momente:'); curPos.y+=3
            pdf.addImage(await context.dispatch('SvgToPng',{Knoten: true, Stäbe: true, Auflager: true, Belastung: false, Auflagerreaktionen: true, Schnittkräfte: {Normalkräfte: false, Querkräfte: false, Momente: true}}), 'PNG', 20, curPos.y, 180, imgHight)
            curPos.y+= (imgHight+8)
            await context.dispatch('CheckNewPage', {doc: pdf, curPos: curPos, height: imgHight+7})
            pdf.setFontSize(12);pdf.setFontType('normal'); pdf.text(20, curPos.y, 'Verformungen:'); curPos.y+=3
            pdf.addImage(await context.dispatch('SvgToPng',{Knoten: true, Stäbe: true, Auflager: true, Belastung: false, Auflagerreaktionen: false, Schnittkräfte: {Normalkräfte: false, Querkräfte: false, Momente: false, Verformungen: true}}), 'PNG', 20, curPos.y, 180, imgHight)
        
        }

        pdf.save('myPDF.pdf');
        context.state.pending=false
    }
  },
  modules: {
      interactions
  }
})
